export var getPhoneIndexByCPhoneShortCut = function (shortcut, tAddPhones) {
    var index = tAddPhones.findIndex(function (tAddPhone) { return tAddPhone.ID_C_PHONE === shortcut; });
    return index;
};
